/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What range of numbers is supported?`)
};

const es_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué rango de números se admite?`)
};

const de_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcher Zahlenbereich wird unterstützt?`)
};

const nl_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk bereik van getallen wordt ondersteund?`)
};

const fr_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle plage de nombres est prise en charge ?`)
};

const it_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale intervallo di numeri è supportato?`)
};

const pt_br2_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o intervalo de números suportado?`)
};

const pt_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que intervalo de números é suportado?`)
};

const ja_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの範囲の数字がサポートされていますか？`)
};

const zh_nw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持的数字范围是多少？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_faq1_q", locale)
	if (locale === "en") return en_nw_faq1_q(inputs)
	if (locale === "es") return es_nw_faq1_q(inputs)
	if (locale === "de") return de_nw_faq1_q(inputs)
	if (locale === "nl") return nl_nw_faq1_q(inputs)
	if (locale === "fr") return fr_nw_faq1_q(inputs)
	if (locale === "it") return it_nw_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_nw_faq1_q(inputs)
	if (locale === "pt") return pt_nw_faq1_q(inputs)
	if (locale === "ja") return ja_nw_faq1_q(inputs)
	return zh_nw_faq1_q(inputs)
};